import React, { FC, Children } from 'react';
import { useStyles } from './styles';

export interface GridProps {
  column: number;
  gutter?: number;
  onClick?: (...args: any[]) => any;
}

const Grid: FC<GridProps> = ({ column, gutter, children, onClick }) => {
  const styles = useStyles([column, gutter]);

  return (
    <div className={styles.grid} onClick={onClick}>
      {Children.toArray(children).map((child, index) => (
        <div key={index} className={styles.item}>
          {child}
        </div>
      ))}
    </div>
  );
};

Grid.defaultProps = {
  gutter: 0
};

export default Grid;
